import classNames from 'classnames';

import { CardItem } from 'src/app/components/Elements/Card';

import styles from './styles.module.scss';

export const NoFamilyPrompt = () => (
  <CardItem className={styles.noFamilyContainer}>
    <h3 className={classNames(styles.title)}>Family Members</h3>
    <p className={classNames(styles.noFamily)}>
      You haven&#8217;t added any <br className={styles.wrap} /> family members
    </p>
    <p className={styles.familyText}>•&nbsp; Manage your family&#8217;s medications in one place</p>
    <p className={styles.familyText}>•&nbsp; Bundle free same-day delivery</p>
  </CardItem>
);
